module.exports = __webpack_public_path__ + "da47cc12f823c686a82481c1d3e8ba2f.png";